import { Colors } from "@constants";
import React from "react";
import { Text, TouchableOpacity, StyleSheet, StyleProp, ViewStyle } from "react-native";

type ButtonProps = {
  children: React.ReactNode;
  onPress: () => void;
  type?: "primary" | "secondary";
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
};

export function Button({
  children,
  onPress,
  type = "primary",
  disabled = false,
  style = {},
}: ButtonProps) {
  const isPrimary = type === "primary";

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={[
        styles.button,
        isPrimary ? styles.nextButton : styles.cancelButton,
        disabled && styles.disabledButton,
        style,
      ]}
    >
      <Text style={isPrimary ? styles.nextButtonText : styles.cancelButtonText}>
        {children}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    minWidth: 110,
    paddingVertical: 10,
    paddingHorizontal: 18,
    borderRadius: 5,
    alignItems: "center",
    marginHorizontal: 4,
  },
  cancelButton: {
    backgroundColor: Colors.white,
    borderColor: Colors.black,
    borderWidth: 1,
  },
  cancelButtonText: {
    color: Colors.black,
    fontWeight: "bold",
  },
  nextButton: {
    backgroundColor: Colors.foodiDefault,
    borderColor: Colors.black,
  },
  nextButtonText: {
    color: Colors.black,
    fontWeight: "bold",
  },
  disabledButton: {
    opacity: 0.5,
  },
});
